<template>
  <div>
    <div style="margin-bottom:5px" :class="['dropdown_select_container', !isEditable ? 'view_only' : '']">
      <v-select v-if="isEditable" style="min-width:265px" v-model="orderMetadata.financeUserId" @input="viewModal"
        :reduce="(user) => user.id" label="nameLabel" :options="filteredUsers" placeholder="Choose..." :disabled="$route.params.id <= 0 ||
          isReadOnly ||
          !(isLogistics || isFinance || isSponsor) ||
          isCompletedOrder || !isEditable
          ">
        <template v-slot:option="option">
          {{ option.nameLabel }}

        </template>
      </v-select>
      <p class="dropdown_text_wrap" v-else> <i v-if="selectedUserLabel.isLocked && !isPartnerAccount" class="tim-icons icon-lock-circle"
          aria-hidden="true"></i>
        {{ selectedUserLabel.label }}</p>

      <el-button style="margin-left:2px" size="mini" v-if="
        ($route.params.id != 0 ||
          (isLogistics || isFinance || isSponsor) ||
          !isReadOnly ||
          !isCompletedOrder) && !isPartnerAccount
      " :class="isEditable ? 'editing' : 'btn-secondary'" v-show="!isReadOnly"
        :icon="isEditable ? 'el-icon-close' : 'el-icon-edit'" @click="toggleEdit()"
        :disabled="$route.params.id <= 0"></el-button>
    </div>
    <!-- small modal -->
    <modal :show.sync="modals.notice" headerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="title title-up">CHANGE FINANCE USER</h4>
      <hr />
      <div class="container">
        <div class="form-group">
          <base-checkbox v-model="sendAssignerCopy">Send Me a Copy</base-checkbox>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Note">
              <textarea class="form-control" placeholder="Add a brief description" rows="5" v-model="note"></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button style="margin-right: 2px" type="danger" class="alert_footer_button btn_extra_small btn_info"
            @click.native="cancel">
            Close
          </base-button>
          <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="confirm">
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Modal, BaseButton, BaseCheckbox } from "@/components";
import { EventBus } from "@/event-bus.js";
import {
  Button,
} from "element-ui";
export default {
  name: "finance-user-select",
  // this orderIdProp is used to edit transaction in a modal method, it will be passed in from the transaction Index page
  // if we go this way. it can be removed if we don't use the modal method
  props: ["isFinanceUser", "isLogisticsUser", "isReadOnly", "orderIdProp"],
  data() {
    return {
      modals: {
        notice: false,
      },
      sendAssignerCopy: false,
      note: null,
      selectedUserId: null,
      isEditable: false
    };
  },
  components: {
    Modal,
    BaseButton,
    BaseCheckbox,
    EventBus,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      financeUsers: "users/financeUsers",
      orderMetadata: "orderMetadata/orderMetadata",
      financeUserId: "orderMetadata/financeUserId",
      isLogistics: "authentication/isLogistics",
      isFinance: "authentication/isFinance",
      isPartnerAccount: "authentication/isPartnerAccount",
      isSponsor: "authentication/isSponsor",
      transaction: "transactions/transaction",
    }),
    isCompletedOrder() {
      return this.orderMetadata.orderStatus == "COMPLETED";
    },
    selectedUserLabel() {
      // Three-step user resolution:
      // 1) orderMetadata.financeUserNameLabel - authoritative source from backend (Name (email) format)
      // 2) financeUsers dropdown array - for locked status detection and editing
      // 3) transaction.financeUser object - backup for locked status
      
      let userIdToFind;

      if (this.selectedUserId) {
        userIdToFind = this.selectedUserId;
      } else {
        userIdToFind = this.financeUserId;
      }

      // If no user ID, return default message
      if (!userIdToFind) {
        return { label: 'No Finance user selected', isLocked: false };
      }

      // Primary: Use orderMetadata label (always available from backend)
      if (this.orderMetadata && this.orderMetadata.financeUserNameLabel) {
        // Check if user is locked via dropdown array or transaction
        let isLocked = false;
        const selectedUser = this.financeUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
        if (selectedUser) {
          isLocked = selectedUser.isDisabled || false;
        } else if (this.transaction && this.transaction.financeUser) {
          const finUser = this.transaction.financeUser;
          if ((finUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase()) {
            isLocked = finUser.isDisabled || false;
          }
        }
        return { label: this.orderMetadata.financeUserNameLabel, isLocked: isLocked };
      }

      // Fallback for dropdown array (when editing)
      const selectedUser = this.financeUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
      if (selectedUser) {
        return { label: selectedUser.nameLabel, isLocked: selectedUser.isDisabled || false };
      }

      // Fallback for transaction object
      if (this.transaction && this.transaction.financeUser) {
        const finUser = this.transaction.financeUser;
        const finUserIdMatch = (finUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase();
        if (finUserIdMatch) {
          const userName = (finUser.userName && finUser.userName.trim()) ? finUser.userName : finUser.userEmail;
          return {
            label: `${userName} (${finUser.userEmail})`,
            isLocked: finUser.isDisabled || false
          };
        }
      }

      // Should never reach here - backend always provides label
      return { label: 'No Finance user selected', isLocked: false };
    },
    filteredUsers() {
      // 1) Start from unlocked finance users only (locked users are not selectable)
      const base = this.financeUsers.filter(u => !u.isDisabled);

      // 2) Add the currently assigned user to the options if it is missing
      // This allows the component to resolve and display the selected label during edit
      const selectedId = (this.orderMetadata && this.orderMetadata.financeUserId)
        ? this.orderMetadata.financeUserId
        : this.selectedUserId;

      if (!selectedId) {
        return base;
      }

      const matchById = (a, b) => (a || "").toLowerCase() === (b || "").toLowerCase();

      const selectedInAll = this.financeUsers.find(u => matchById(u.id, selectedId));
      const alreadyInBase = base.find(u => matchById(u.id, selectedId));

      if (selectedInAll && !alreadyInBase) {
        return [selectedInAll, ...base];
      }

      // 3) If the assigned user isn't in any list but exists in the transaction payload,
      // create a minimal option so the dropdown shows a friendly label instead of a GUID
      const finFromTx = this.transaction && this.transaction.financeUser;
      if (!selectedInAll && finFromTx && matchById(finFromTx.userId, selectedId)) {
        const synthesized = {
          id: selectedId,
          nameLabel: (finFromTx.userName && finFromTx.userName.trim())
            ? finFromTx.userName
            : finFromTx.userEmail,
          lockedBy: finFromTx.lockedBy,
        };
        return [synthesized, ...base];
      }

      // 4) Default
      return base;
    }
  },
  async mounted() {
    // either use prop order id or the param order id
    let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
    await this.getOrderMetadata(id);
    await this.getTransaction(id);
    this.selectedUserId = this.orderMetadata.financeUserId
  },
  methods: {
    ...mapActions({
      onFinanceChange: "orderMetadata/onFinanceChange",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      getTransaction: "transactions/getTransaction",

    }),
    async cancel(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
      await ctx.getOrderMetadata(id);
      ctx.modals.notice = false;
      this.selectedUserId = this.orderMetadata.financeUserId
    },
    viewModal(e) {
      if (e) {
        this.selectedUserId = e;
        this.modals.notice = true;
      }
    },
    async toggleEdit() {
      if (this.isEditable) {
        await this.cancel();
        this.orderMetadata.financeUserId = this.selectedUserId
        this.isEditable = false
      } else {
        this.isEditable = true
      }
    },

    async confirm(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
      try {
        this.$loaderApp.addRequest();

        if (this.selectedUserId == null) {
          ctx.$toast.error("Please select a user!");
          ctx.modals.notice = false;
          this.$loaderApp.completeRequest();
          this.isEditable = false
          return;
        }
        await ctx.onFinanceChange({
          orderId: id,
          sendAssignerCopy: ctx.sendAssignerCopy,
          note: ctx.note,
          selectedUserId: ctx.selectedUserId,
        });
        ctx.modals.notice = false;
        EventBus.$emit('finance-user-change', id);
        this.$loaderApp.completeRequest();
        this.isEditable = false

      } catch (error) {
        ctx.$toast.error("Error Occurred! Please try again later.");
        this.$loaderApp.completeRequest();
        this.isEditable = false

      }
    },
  },
};
</script>
<style>
.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}
</style>